<ng-template [ngIfElse]="userRef" [ngIf]="loading || !user">
  <app-skeleton [stats]="'profile'"></app-skeleton>
</ng-template>

<ng-template #userRef>
  <app-user-profile [isModal]="isModal"
                    [me]="me"
                    [profile]="profile"
                    [selectedSubjectId]="selectedSubjectId"
                    [user]="user"
                    (isCloseAllModals)="closeAllModals()">
  </app-user-profile>
</ng-template>
